/* eslint-disable @eslint-react/component-hook-factories */
import { Component, type ComponentType } from 'react'
import { ThemeContext } from '@/contexts'

const withTheme = <P extends object>(WrappedComponent: ComponentType<P & { theme: any; setTheme: any }>) => {
  return class WithTheme extends Component<Omit<P, 'theme' | 'setTheme'> & { innerRef?: any }> {
    render() {
      const {
        innerRef,
        ...props
      } = this.props

      return (
        <ThemeContext.Consumer>
          {(context) => {
            const { theme, setTheme } = context as any
            return (
              <WrappedComponent
                {...(props as P)}
                ref={innerRef}
                theme={theme}
                setTheme={setTheme}
              />
            )
          }}
        </ThemeContext.Consumer>
      )
    }
  }
}

export default withTheme
